module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/Users/metabase/code/releases/release-2023-02-21/metabase-0.45.3/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/Users/metabase/code/releases/release-2023-02-21/metabase-0.45.3/frontend/src/metabase-lib/metadata/utils/ga-metadata.js"));
    });
  });
}